
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { environment } from '../../../../environments/environment';
import { TranslateService } from "@ngx-translate/core";
import { CustomerService } from "../../services/customer.service";
import { FileUploadConstants } from "../../constants/file-upload.constants";
import { ReportService } from "../../services/report.service";
import { CommonService } from "../../../shared/services/common.service";
import { NotificationType } from "../../enums/notification-types.enum";
import { MemberTypeEnum } from "../../enums/member-type.enum";
import { StatusConstants } from "../../constants/status.constants";
import { DistributorIdFormatPipe } from "../../../common/pipes/distributor-id-format.pipe";
import { StoreConfig } from "../../../shared/interface/StoreConfig.interface";
import { CurrencyTransformPipe } from "../../../common/pipes/currency-format.pipe";
import { PaginationInstance } from "ngx-pagination";



@Component({
    selector: 'app-account-status-change-reports',
    templateUrl: '../../templates/template1/views/reports/account-status-change-report.component.html',
    styleUrls: [
        '../../templates/template1/themes/default/less/account-status-change-report.component.less'
    ],
    providers: [DistributorIdFormatPipe, CurrencyTransformPipe]
})
export class AccountStatusChangeReportComponent implements OnInit {
    @Input() fromDate: string;
    @Input() toDate: string;
    @Input() storeId: [number];
    @Output() isLoadedData = new EventEmitter<boolean>();
    @Input() storeInfo: StoreConfig;
    @Input() previousStatus: string;
    @Input() newStatus: string;
    pageSizes = [25, 50, 75, 100, 125, 150, 175, 200];
    pageNumber: number = 1;
    pageSize: number = 25;
    pageCount: number = 0;
    public paginationInstance: PaginationInstance = {
        id: 'status-changes-reports-pagination',
        itemsPerPage: 10,
        currentPage: 1
    }
    currentDate = new Date();
    excelIconUrl = environment.cdnURL + '/flpi/images/ms_excel.ico';
    printIconUrl = environment.cdnURL + '/flpi/images/print_icon.png';
    statusChangeReport = [];
    allStatusChangeReport = [];
    isResponseError = false;
    isLoading = false;
    isAllStatusChangeReportLoading = false;
    isShowReport = true;
    csvType = FileUploadConstants.CSV_FILE_EXTENSION;
    printType = FileUploadConstants.PRINT;


    constructor(
        private _translateService: TranslateService,
        private _customerservice: CustomerService,
        private _reportService: ReportService,
        private _commonService: CommonService
    ) { }

    ngOnInit(): void {
        // this.getAccountStatusChangeReport();
        this.exportFile('csv');
    }

    /**
     * To get account status change report
     * @returns void
     */
    getAccountStatusChangeReport(): void {
        this.isLoading = true;
        this.statusChangeReport = [];
        this._reportService.getAccountStatusChangeReport(this.storeId, this.fromDate, this.toDate, this.previousStatus, this.newStatus, this.pageNumber, this.pageSize, false).subscribe(response => {
            if (response && response.content) {
                const statusChangesResponse = response.content;
                statusChangesResponse.forEach(element => {
                    element.memberType = this.getMemberType(parseInt(element.memberType));
                    this.statusChangeReport.push(element)
                });
                this.isLoading = false;
                this.isResponseError = false;
                this.pageCount = response.totalCount;
                this.isLoadedData.emit(true);
               
            }
            else if (response && response.status && response.status.code === 504) {
                const message: any = this._translateService.get('reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again');
                this._commonService.createNotification('', message.value, NotificationType.ERROR);
                this.setDefaultValues();
            }
            else {
                this.setDefaultValues();
            }
        }, (error) => {
            if (error.status == 504 || (error.name && error.name.toLowerCase() == 'typeerror')) {
                const message: any = this._translateService.get('reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again');
                this._commonService.createNotification('', message.value, NotificationType.ERROR);
                this.setDefaultValues();
            }
            else {
                const message: any = this._translateService.get('reports.Something Went Wrong, Please try again after some time');
                this._commonService.createNotification('', message.value, NotificationType.ERROR);
                this.setDefaultValues();
            }
        });
    }

    /**
     * To Set Default Values
     */
    setDefaultValues(): void {
        this.statusChangeReport = [];
        this.isLoading = false;
        this.isResponseError = true;
        this.pageCount = 0;
        this.isLoadedData.emit(true);
    }

    /**
    * To change page size
    * @param  {number} pageSize
    * @returns void
    */
    pageSizeChange(pageSize: number): void {
        if (pageSize) {
            this.pageNumber = 1;
            this.pageSize = pageSize;
            this.getAccountStatusChangeReport();
        }
    }

    /**
     * To change page number
     * @param  {number} pageNumber
     */
    pageChange(pageNumber: number) {
        this.pageNumber = pageNumber;
        this.getAccountStatusChangeReport();
    }

    /**
     * To Export The file
     */
    exportFile(type): void {
        // if (this.allStatusChangeReport && this.allStatusChangeReport.length > 0) {
        //     this.download(type);
        // } else {
        //     this.fetchAllAccountStatusChangeReport(type);
        // }
        this.fetchAllAccountStatusChangeReport(type);
    }

    /**
     * To Fetch all account status changes report data from service
     */
    fetchAllAccountStatusChangeReport(type): void {
        this.isAllStatusChangeReportLoading = true;
        this.allStatusChangeReport = [];
        this.isLoading = true;
        this.statusChangeReport = [];
        this._reportService.getAccountStatusChangeReport(this.storeId, this.fromDate, this.toDate, this.previousStatus, this.newStatus, this.pageNumber, this.pageSize, true).subscribe(response => {
            if (response) {
                this.isAllStatusChangeReportLoading = false;
                const allSatusChangesResponse = response.content;
                allSatusChangesResponse.forEach(element => {
                    element.memberType = this.getMemberType(element.memberType);
                    this.allStatusChangeReport.push(element)
                });
                this.statusChangeReport = this.allStatusChangeReport;
                this.isLoading = false;
                this.isResponseError = false;
                this.pageCount = response.totalCount;
                this.isLoadedData.emit(true);
                this.download(type);
            } else {
                this.isAllStatusChangeReportLoading = false;
                this.allStatusChangeReport = null;
                this.setDefaultValues();
            }
        }, (error) => {
            const message: any = this._translateService.get('reports.Something Went Wrong, Please try again after some time');
            this._commonService.createNotification('', message.value, NotificationType.ERROR);
            this.allStatusChangeReport = null;
            this.isAllStatusChangeReportLoading = false;
            this.setDefaultValues();
        });
    }

    /**
     * To download CSV or Print file from response data
     * @param  {string} type
     * @returns void
     */
    download(type: string): void {
        const allReportLength = this.allStatusChangeReport && this.allStatusChangeReport.length ?
            this.allStatusChangeReport && this.allStatusChangeReport.length : null;
        if (allReportLength > 0) {

            const columns = [
                this._translateService.get('reports.ID #')['value'],
                this._translateService.get('reports.Last Name')['value'],
                this._translateService.get('reports.First Name')['value'],
                this._translateService.get('reports.Member Type')['value'],
                this._translateService.get('reports.Previous Status')['value'],
                this._translateService.get('reports.New Status')['value'],
                this._translateService.get('reports.User')['value'],
                this._translateService.get('reports.Notes')['value']
            ];
            const title = this._translateService.get('reports.Account Status Changes Report')['value'] + "_" + this.fromDate + this._translateService.get('reports._To_')['value'] + this.toDate;
            if (type === this.csvType) {
                this.downloadCSV(columns, allReportLength);
            } else if (type === this.printType) {
                this.printReportDetails(title, columns, allReportLength);
            }
        }
    }

    /**
    * To get the member type for account status changes report details
    */
    getMemberType(memberType: any): string {
        if (memberType === MemberTypeEnum.DISTRIBUTOR) {
            memberType = StatusConstants.FBO;
        }
        if (memberType === MemberTypeEnum.RETAIL) {
            memberType = StatusConstants.Retail;
        }
        if (memberType === MemberTypeEnum.GUEST) {
            memberType = StatusConstants.GUEST;
        }
        if (memberType === MemberTypeEnum.FPC) {
            memberType = StatusConstants.FPC;
        }
        return memberType;
    }

    /**
     * CSV file download functionality
     */
    downloadCSV(columns: any, allReportLength: any) {
        let rowdata = new Array<any>();
        const finalrows = new Array<any>();
        for (let i = 0; i < allReportLength; i++) {
            rowdata = [];
            const row = this.allStatusChangeReport[i];
            rowdata.push(row.distributorId);
            rowdata.push(row.lastName);
            rowdata.push(row.firstName);
            rowdata.push(row.memberType);
            rowdata.push(row.previousStatus);
            rowdata.push(row.newStatus);
            rowdata.push(row.userFirstName + ' ' + row.userLastName);
            rowdata.push(row.description);
            finalrows.push(rowdata);
        }
        this._customerservice.ExcelDownload(columns, finalrows, (this._translateService.get('reports.Account Status Changes Report')['value']), '', false);
    }

    /**
     * Print functionality for report details printing
     */
    printReportDetails(title: string, columns: any, allReportLength: any) {
        let rowdataForPrint = new Array<any>();
        const finalrowsForPrint = new Array<any>();
        for (let i = 0; i < allReportLength; i++) {
            rowdataForPrint = [];
            const rowForPrint = this.allStatusChangeReport[i];
            rowdataForPrint.push(rowForPrint.distributorId);
            rowdataForPrint.push(rowForPrint.lastName);
            rowdataForPrint.push(rowForPrint.firstName);
            rowdataForPrint.push(rowForPrint.memberType);
            rowdataForPrint.push(rowForPrint.previousStatus);
            rowdataForPrint.push(rowForPrint.newStatus);
            rowdataForPrint.push(rowForPrint.userFirstName + ' ' + rowForPrint.userLastName);
            rowdataForPrint.push(rowForPrint.description);
            finalrowsForPrint.push(rowdataForPrint);
        }
        this._customerservice.constructTableAndPrint(columns, finalrowsForPrint, title);
    }
}




// WEBPACK FOOTER //
// ./src/app/customerservice/components/reports/account-status-change-report.component.ts